import { render, staticRenderFns } from "./Bunner.vue?vue&type=template&id=4760b631&"
import script from "./Bunner.vue?vue&type=script&lang=js&"
export * from "./Bunner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports